import * as types from "./types";
import INITIAL_STATE from "./init";

// style guide: avoid destructuring state

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SET_CUSTOMER:
      return {
        ...state,
        ...action.payload,
      };

    case types.SET_NAME:
      return {
        ...state,
        name: action.payload,
      };

    case types.SET_TITLE:
      return {
        ...state,
        title: action.payload,
      };

    case types.SET_COUNTRY_CODE:
      return {
        ...state,
        country_code: action.payload,
      };

    case types.SET_CELL_PHONE:
      return {
        ...state,
        cell_phone: action.payload,
      };

    default:
      return state;
  }
};
